import styled from 'styled-components';

interface PropsShow {
    show: boolean;
}

export const ContainerPage = styled.div`
  width: 100%;
  max-width: 1140px; 
  margin-left: auto;
  margin-right: auto;
  

  padding: 20px; 

  .filters {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 1rem;
    width: 100%;
    margin-bottom: 2rem;
    flex-wrap: wrap;
  }

  .filter-input {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: fit-content;
    flex-direction: column;
  }
`;

export const Container = styled.div`
  
  /* margin-top: 80px; */
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  

  .conten-cards-imoveis {
    max-width: 1200px;
    padding: 0 4%;
    margin: 0 auto;

    .slide {
      gap: 1rem;
    }

    h3 {
      font-weight: bold;
      margin-bottom: 1rem;
    }

    .imoveis {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;

      .card {
        width: 100%;
        height: 230px;
        border-radius: 1rem;
        background-color: rgba(0,0,0, .2);
      }
    }
  }
  

  @media screen and (max-width: 980px) {
    .imoveis {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media screen and (max-width: 760px) {
    .imoveis {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media screen and (max-width: 500px) {
    .imoveis {
      grid-template-columns: 1fr;
    }
  }
`;

export const Content = styled.div<PropsShow>`
  min-height: 1000px;

  .header {
    position: relative;
    
    
    .placeholder-header {
      width: 100%;
      height: 300px;
      object-fit: cover;

      @media screen and (max-width:800px){
        height: auto;
        object-fit: contain;
      }
    }
    .logo-white {
      position: absolute;
      right: 2rem;
      bottom: 2rem;
      width: 200px;

      @media screen and (max-width:800px){
        width: 100px;
        right: 1rem;
        bottom: 1rem;
      }
    }

    
  }
  
  .body {
    max-width: 1200px;
    margin: 5rem auto 0 auto;
    position: relative;

    @media screen and (max-width:800px){
      padding: 0 1rem;
    }

    .avatar {
      color: var(--gray-one);
      width: 200px;
      height: 200px;
      border: 6px solid white;
      position: absolute;
      top: -14rem;
      object-fit: cover;
      
      border-radius: 200px;
      /* box-shadow: 0px 0px 32px rgba(0,0,0, .5); */

      @media screen and (max-width:800px){
        width: 150px;
        height: 150px;
        top: -12rem;
      }
    }

    .title-and-others {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-and-infos {
        .name-corretor {
          color: var(--color-title-home);
          font-size: 2.2rem;
          margin-top: -14px;
          margin-bottom: 0px;
          letter-spacing: -2px;

          @media screen and (max-width:800px){
            font-size:1.5rem;
            margin: -1.5rem 0 0;
          }
        }
        .class {
          margin:0;
          display: flex;
          align-items: center;
          font-size: 1.2rem;
          color: var(--color-title-home);
          opacity: .8;
          .check-corretor {
            color: var(--primary-green);
            margin-left: 0.5rem;
          }

          @media screen and (max-width:800px){
            font-size: .9rem;
            margin: .3rem 0 0;
          }
        }
        .creci {
          margin-top:12px;
          color: #212e4d;
          font-weight: 700;

          @media screen and (max-width:800px){
            font-size:.7rem;
          }
        }
      }

      .qr-code {
        width: 100px;
        height: 100px;
      }

      .icons-social-midias {
        display: flex;
        gap: 2rem;

        @media screen and (max-width:800px){
          gap:.5rem;
        }

        a {
          text-decoration: none;
        }

        .icons-midias {
          /* border: 1px solid var(--color-title-home);; */
          font-size: 2.5rem;
          padding: 0.5rem;
          color: var(--color-title-home);
          border-radius: 5px;
          cursor: pointer;

          @media screen and (max-width:800px){
            font-size:2rem;
          }
        }
      }
      .avaliation {
        .value-avaliation {
          display: flex;
          align-items: center;
          margin: 0;
          font-size: 3rem;
          font-weight: 700;
          letter-spacing: -3px;
          .star {
            font-size: 2.7rem;
            margin-left: 0.5rem;
          }
        }
        .content-medals {
          display: flex;
          align-items: center;
          justify-content: center;
          gap:0.2rem;
          .ouro {
            font-size: 1.5rem;
            color: var(--gold-primary);
          }
          .prata {
            font-size: 1.5rem;
            color: var(--silver-primary);
          }
          .bronze {
            font-size: 1.5rem;
            color: var(--bronze-primary);
          }
        }
      }
    }
    
  }
  .traco {
    margin: 1rem 4rem;
    width: calc(100% - 8rem);
    height: 1px;
    background-color: var(--gray-one);
    opacity: .6;
  }

`;
